// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vOqZO","largestCol":"styles_largestCol__2iXi2","smallestCol":"styles_smallestCol__1-Ryk"};